import { render, staticRenderFns } from "./QUX.vue?vue&type=template&id=67298a28&"
import script from "./QUX.vue?vue&type=script&lang=js&"
export * from "./QUX.vue?vue&type=script&lang=js&"
import style0 from "./QUX.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QUX.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports